<template>
  <q-page padding>
    <PageHeader
      title="Criação de Ativos em Massa"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-md bg-accent"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="crie" label="CRIAÇÃO DE ITENS CATÁLOGO" />
      <q-tab name="crieAtivos" label="CRIAÇÃO DE ATIVOS" />
      <q-tab name="remova" label="EXCLUSÃO DE ATIVOS" />
      <q-tab
        name="associeAcessorio"
        label="ASSOCIAÇÃO ACESSÓRIO A ITEM CATÁLOGO"
      />
      <q-tab
        name="associeAtributos"
        label="ASSOCIAÇÃO ATRIBUTOS A ITEM CATÁLOGO"
      />
      <q-tab
        name="associeChecklists"
        label="ASSOCIAÇÃO CHECKLISTS A ITEM CATÁLOGO"
      />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <!-- ===== CRIAÇÃO DE ITENS CATÁLOGO ===== -->
      <q-tab-panel name="crie">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            CRIAÇÃO DE ITENS CATÁLOGO
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide = !activeSlide"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosCrie"
          :showUnidade="false"
          :activeSlide="activeSlide"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_Criação_Itens_Catalogo.xlsx"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4"><lista-unidades-select /></div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de criação de itens catálogo
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file1, 'drag-over': isDragOver1 }"
              @dragover.prevent="isDragOver1 = true"
              @dragleave.prevent="isDragOver1 = false"
              @drop.prevent="onDrop(1, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file1">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file1.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file1 ? 'positive' : 'primary'"
                      :icon="file1 ? 'check_circle' : 'folder_open'"
                      :label="
                        file1 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput1.click()"
                    />
                    <input
                      ref="fileInput1"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(1, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file1">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file1.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file1.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file1 || isLoading"
                @click="enviar(1, 'criacao_itens_catalogo')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== CRIAÇÃO DE ATIVOS ===== -->
      <q-tab-panel name="crieAtivos">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            CRIAÇÃO DE ATIVOS
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide2 = !activeSlide2"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosCrieAtivos"
          :showUnidade="false"
          :activeSlide="activeSlide2"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_Criação_ativos.xlsx"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4"><lista-unidades-select /></div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">Enviar planilha de criação de ativos</h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file2, 'drag-over': isDragOver2 }"
              @dragover.prevent="isDragOver2 = true"
              @dragleave.prevent="isDragOver2 = false"
              @drop.prevent="onDrop(2, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file2">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file2.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file2 ? 'positive' : 'primary'"
                      :icon="file2 ? 'check_circle' : 'folder_open'"
                      :label="
                        file2 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput2.click()"
                    />
                    <input
                      ref="fileInput2"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(2, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file2">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file2.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file2.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file2 || isLoading"
                @click="enviar(2, 'criacao_ativos')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== EXCLUSÃO DE ATIVOS ===== -->
      <q-tab-panel name="remova">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            EXCLUSÃO DE ATIVOS
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide3 = !activeSlide3"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosRemova"
          :showUnidade="false"
          :activeSlide="activeSlide3"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_Exclusão_ativos.xlsx"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4"><lista-unidades-select /></div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">Enviar planilha de exclusão de ativos</h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file3, 'drag-over': isDragOver3 }"
              @dragover.prevent="isDragOver3 = true"
              @dragleave.prevent="isDragOver3 = false"
              @drop.prevent="onDrop(3, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file3">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file3.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file3 ? 'positive' : 'primary'"
                      :icon="file3 ? 'check_circle' : 'folder_open'"
                      :label="
                        file3 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput3.click()"
                    />
                    <input
                      ref="fileInput3"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(3, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file3">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file3.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file3.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file3 || isLoading"
                @click="enviar(3, 'exclusao_ativos')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== ASSOCIAÇÃO ACESSÓRIO ===== -->
      <q-tab-panel name="associeAcessorio">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ASSOCIAÇÃO ACESSÓRIO A ITEM CATÁLOGO
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide4 = !activeSlide4"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosAssocieAcessorio"
          :showUnidade="false"
          :activeSlide="activeSlide4"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_associação_acessorio_item_catalogo.xlsx"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4"><lista-unidades-select /></div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de associação acessório a item catálogo
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file4, 'drag-over': isDragOver4 }"
              @dragover.prevent="isDragOver4 = true"
              @dragleave.prevent="isDragOver4 = false"
              @drop.prevent="onDrop(4, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file4">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file4.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file4 ? 'positive' : 'primary'"
                      :icon="file4 ? 'check_circle' : 'folder_open'"
                      :label="
                        file4 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput4.click()"
                    />
                    <input
                      ref="fileInput4"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(4, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file4">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file4.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file4.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file4 || isLoading"
                @click="enviar(4, 'associacao_acessorio_item_catalogo')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== ASSOCIAÇÃO ATRIBUTOS ===== -->
      <q-tab-panel name="associeAtributos">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ASSOCIAÇÃO ATRIBUTOS A ITEM CATÁLOGO
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide5 = !activeSlide5"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosAssocieAtributos"
          :showUnidade="false"
          :activeSlide="activeSlide5"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_associação_atributos_item_catalogo.xlsx"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4"><lista-unidades-select /></div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de associação atributos a item catálogo
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file5, 'drag-over': isDragOver5 }"
              @dragover.prevent="isDragOver5 = true"
              @dragleave.prevent="isDragOver5 = false"
              @drop.prevent="onDrop(5, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file5">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file5.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file5 ? 'positive' : 'primary'"
                      :icon="file5 ? 'check_circle' : 'folder_open'"
                      :label="
                        file5 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput5.click()"
                    />
                    <input
                      ref="fileInput5"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(5, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file5">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file5.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file5.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file5 || isLoading"
                @click="enviar(5, 'associacao_atributos_item_catalogo')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== ASSOCIAÇÃO CHECKLISTS ===== -->
      <q-tab-panel name="associeChecklists">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ASSOCIAÇÃO CHECKLISTS A ITEM CATÁLOGO
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide6 = !activeSlide6"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosAssocieChecklists"
          :showUnidade="false"
          :activeSlide="activeSlide6"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/ferramentaria/Template_atv_associação_checklist_item_catalogo.xlsx"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4"><lista-unidades-select /></div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de associação checklists a item catálogo
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file6, 'drag-over': isDragOver6 }"
              @dragover.prevent="isDragOver6 = true"
              @dragleave.prevent="isDragOver6 = false"
              @drop.prevent="onDrop(6, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file6">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file6.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file6 ? 'positive' : 'primary'"
                      :icon="file6 ? 'check_circle' : 'folder_open'"
                      :label="
                        file6 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput6.click()"
                    />
                    <input
                      ref="fileInput6"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(6, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file6">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file6.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file6.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file6 || isLoading"
                @click="enviar(6, 'associacao_checklists_item_catalogo')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import InfotUpload from "../../legado/compras/components/InfotUpload.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: { InfotUpload, ListaUnidadesSelect, PageHeader },

  setup() {
    const store = useStore();
    const $q = useQuasar();
    const catalogoUuidComposable = salvarCatalogoUuid();
    const isLoading = ref(false);

    const activeSlide = ref(false);
    const activeSlide2 = ref(false);
    const activeSlide3 = ref(false);
    const activeSlide4 = ref(false);
    const activeSlide5 = ref(false);
    const activeSlide6 = ref(false);

    const file1 = ref(null);
    const file2 = ref(null);
    const file3 = ref(null);
    const file4 = ref(null);
    const file5 = ref(null);
    const file6 = ref(null);
    const fileInput1 = ref(null);
    const fileInput2 = ref(null);
    const fileInput3 = ref(null);
    const fileInput4 = ref(null);
    const fileInput5 = ref(null);
    const fileInput6 = ref(null);
    const isDragOver1 = ref(false);
    const isDragOver2 = ref(false);
    const isDragOver3 = ref(false);
    const isDragOver4 = ref(false);
    const isDragOver5 = ref(false);
    const isDragOver6 = ref(false);

    const files = {
      1: file1,
      2: file2,
      3: file3,
      4: file4,
      5: file5,
      6: file6,
    };

    const formatFileSize = (bytes) => {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    const onFileSelected = (tab, e) => {
      if (e.target.files[0]) files[tab].value = e.target.files[0];
    };

    const onDrop = (tab, e) => {
      const dragRefs = {
        1: isDragOver1,
        2: isDragOver2,
        3: isDragOver3,
        4: isDragOver4,
        5: isDragOver5,
        6: isDragOver6,
      };
      dragRefs[tab].value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        files[tab].value = f;
      } else {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
      }
    };

    const tipoPlanilhaMap = {
      criacao_itens_catalogo: "catalogo_item_criacao",
      criacao_ativos: "ativo_criacao",
      exclusao_ativos: "ativo_exclusao",
      associacao_acessorio_item_catalogo: "catalogo_item_acessorio_associacao",
      associacao_atributos_item_catalogo: "catalogo_item_atributo_associacao",
      associacao_checklists_item_catalogo: "catalogo_item_checklist_associacao",
    };

    const enviar = async (tab, mapeamento) => {
      const fileRef = files[tab];
      if (!fileRef.value || !fileRef.value.name.endsWith(".xlsx")) {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
        return;
      }

      const planilhaTipo = tipoPlanilhaMap[mapeamento];
      if (!planilhaTipo) {
        $q.notify({
          message: "Tipo de planilha não reconhecido",
          color: "negative",
          icon: "warning",
        });
        return;
      }

      if (!catalogoUuidComposable.catalogoUuid.value) {
        $q.notify({
          message: "Nenhum catálogo encontrado para esta unidade",
          color: "negative",
          icon: "warning",
        });
        return;
      }

      isLoading.value = true;
      $q.loading.show({ message: "Enviando planilha..." });

      try {
        const tiposResponse = await store.dispatch(
          "ferramentaria/listarTiposPlanilha"
        );
        const tiposAceitos = tiposResponse.data.resultado.dados;
        if (!tiposAceitos.includes(planilhaTipo)) {
          throw new Error(
            `Tipo de planilha '${planilhaTipo}' não é aceito pelo sistema`
          );
        }

        const urlUploadResponse = await store.dispatch(
          "ferramentaria/buscarUrlUploadPlanilha",
          {
            planilhaTipo,
            nomeArquivo: fileRef.value.name,
          }
        );

        const formAttributes =
          urlUploadResponse.data.resultado.dados.formAttributes;
        const formInputs = urlUploadResponse.data.resultado.dados.formInputs;
        const formData = new FormData();
        for (const input in formInputs) {
          formData.append(input, formInputs[input]);
        }
        formData.append("file", fileRef.value);

        const request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);
        await new Promise((resolve, reject) => {
          request.onload = () =>
            request.status === 200 || request.status === 204
              ? resolve()
              : reject(new Error(`Upload falhou: ${request.status}`));
          request.onerror = () => reject(new Error("Erro no upload"));
          request.send(formData);
        });

        const urlArquivo = `${formAttributes.action}/${formInputs.key}`;
        const usuarioLogado = store.state.autenticacao.usuarioLogado;
        const unidadeData = store.state.org.unidadeData;
        const dadosEnvio = {
          url: urlArquivo,
          catalogoUuid: catalogoUuidComposable.catalogoUuid.value,
          usuarioId: usuarioLogado.id,
          usuarioNome: usuarioLogado.nome,
          unidadeId: unidadeData.id,
          background: true,
        };

        const dispatchMap = {
          criacao_itens_catalogo: "ferramentaria/uploadItemCatalogoPlanilha",
          criacao_ativos: "ferramentaria/uploadAtivosPlanilha",
          exclusao_ativos: "ferramentaria/deleteAtivosPlanilha",
          associacao_acessorio_item_catalogo:
            "ferramentaria/uploadAcessorioItemCatalogoPlanilha",
          associacao_atributos_item_catalogo:
            "ferramentaria/uploadAtributoItemCatalogoPlanilha",
          associacao_checklists_item_catalogo:
            "ferramentaria/uploadChecklistItemCatalogoPlanilha",
        };
        await store.dispatch(dispatchMap[mapeamento], dadosEnvio);

        $q.loading.hide();
        $q.notify({
          message: "Template enviado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        fileRef.value = null;
      } catch (error) {
        $q.loading.hide();
        console.error("Erro detalhado:", error);
        const errorMessage =
          error.response?.data?.erro?.mensagem ||
          error.response?.data?.erro?.detalhes?.catalogoUuid?.[0] ||
          error.response?.data?.result?.error ||
          error.response?.data?.error ||
          error.response?.data?.message ||
          error.response?.data?.erros?.mensagem ||
          error.message ||
          "Erro ao enviar template";
        $q.notify({
          message: errorMessage,
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      } finally {
        isLoading.value = false;
      }
    };

    const infosCrie = ref([
      { name: "As colunas A, B e D são obrigatórias.", icon: "warning" },
      {
        name: "A informação de Grupo e Subgrupo é criada se não existir no primeiro upload.",
        icon: "create",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    const infosCrieAtivos = ref([
      {
        name: "A informação de código e descrição na coluna A e B deve ser igual a um item de catálogo já criado.",
        icon: "warning",
      },
      {
        name: "Os valores para Origem devem ser: Propria, Locada ou Consumo.",
        icon: "warning",
      },
      {
        name: "A coluna de CNPJ Fornecedor deve estar sem formatação como exemplo.",
        icon: "warning",
      },
      {
        name: "A coluna Operação deve condizer com as operações já criadas.",
        icon: "schedule",
      },
      {
        name: "A coluna Local de Deposito deverá condizer com os locais existentes.",
        icon: "warning",
      },
      {
        name: "Não altera a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    const infosRemova = ref([
      {
        name: "A coluna exige o uuid do ativo, presente no Relatório de Ativos.",
        icon: "view_column",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    const infosAssocieAcessorio = ref([
      {
        name: "A informação de codigo e descrição na coluna A e B deve ser igual a um item já criado.",
        icon: "view_column",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    const infosAssocieAtributos = ref([
      {
        name: "A informação de codigo e descrição na coluna A e B deve ser igual a um item já criado.",
        icon: "view_column",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    const infosAssocieChecklists = ref([
      {
        name: "A informação de codigo e descrição na coluna A e B deve ser igual a um item já criado.",
        icon: "view_column",
      },
      { name: "Se o checklist não existir, um será criado.", icon: "create" },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação.",
        icon: "warning",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais.",
        icon: "delete",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação.",
        icon: "timer",
      },
    ]);

    return {
      activeSlide,
      activeSlide2,
      activeSlide3,
      activeSlide4,
      activeSlide5,
      activeSlide6,
      file1,
      file2,
      file3,
      file4,
      file5,
      file6,
      fileInput1,
      fileInput2,
      fileInput3,
      fileInput4,
      fileInput5,
      fileInput6,
      isDragOver1,
      isDragOver2,
      isDragOver3,
      isDragOver4,
      isDragOver5,
      isDragOver6,
      isLoading,
      formatFileSize,
      onFileSelected,
      onDrop,
      enviar,
      infosCrie,
      infosCrieAtivos,
      infosRemova,
      infosAssocieAcessorio,
      infosAssocieAtributos,
      infosAssocieChecklists,
      tab: ref("crie"),
    };
  },
};
</script>

<style scoped>
.upload-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 16px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.header-icon {
  color: #1976d2;
}

.upload-title {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.1rem;
}

.upload-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-area {
  background: white;
  border: 2px dashed #e0e4e7;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.upload-area:hover {
  border-color: #1976d2;
  background: #f8fafe;
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(25, 118, 210, 0.1);
}

.upload-area.file-selected {
  border-color: #4caf50;
  background: #f1f8e9;
}
.upload-area.drag-over {
  border-color: #1976d2;
  background: #e3f2fd;
  transform: scale(1.02);
}

.upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.upload-icon-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.upload-icon {
  color: white;
}

.upload-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.upload-main-text {
  margin: 0;
  color: #546e7a;
  font-size: 1rem;
  font-weight: 500;
}
.upload-main-text.selected {
  color: #2e7d32;
  font-weight: 600;
}
.upload-button {
  cursor: pointer;
}

.upload-btn {
  min-width: 180px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.file-info {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e4e7;
}
.file-details {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}
.upload-actions {
  display: flex;
  justify-content: center;
}

.send-button {
  min-width: 160px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.send-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
</style>
